import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IRestaurantLocalizationGroup } from 'types';
import LocalizationItem from './components/LocalizationItem';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './LocalizationGroup.module.scss';

interface ILocalizationGroup {
	languageId: string;
	groupData: IRestaurantLocalizationGroup;
}

const LocalizationGroup: React.FC<ILocalizationGroup> = ({ languageId, groupData }) => {
	const { selectedLocalizationGroup, selectedLocalizationLanguage } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const headingElement = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (selectedLocalizationGroup?.id === groupData.id && selectedLocalizationLanguage?.id === languageId) {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedLocalizationGroup]);

	return (
		<div className={style.container}>
			<div className={style.heading} ref={headingElement}>
				<Text translationNameSpace="localizationSettings" translationKey={groupData.name} asFragment={true} />
			</div>
			<div className={style.items}>
				{groupData.items.map((el) => (
					<LocalizationItem key={el.key} itemData={el} languageId={languageId} />
				))}
			</div>
		</div>
	);
};

export default LocalizationGroup;
